module.exports = __webpack_public_path__ + "assets/img/22_208_big.914fd8fc.jpg";